import React from 'react'

const PageContext = React.createContext({
    scale: '',
    change: '',
});

export default PageContext;